import {forwardRef, ReactNode, Ref} from 'react'
import {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {WithTheme} from '@yosmanyga/theme'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'

type BottomSheetProps = {
    percentage: string,
    onClose: () => void,

    children?: ReactNode
}

const BottomSheet = forwardRef<unknown, BottomSheetProps>(({
    children,
    ...props
}, ref) => {
    const {BottomSheet: BaseBottomSheet} = usePrimitives()

    if (!BaseBottomSheet) {
        throw new NonExistentPrimitiveError('BottomSheet')
    }

    return <BaseBottomSheet
        ref={ref}
        {...props}
    >
        {children}
    </BaseBottomSheet>
})

const BottomSheetWithTheme = forwardRef<typeof BottomSheet, BottomSheetProps & UnnormalizedStyleProps>((props, ref) => {
    return <WithTheme
        {...props}
        identifier='bottomSheet'
        Component={BottomSheet}
        ref={ref}
    />
});

export default BottomSheetWithTheme
